export default __webpack_public_path__ + "static/media/pattern.9d309135.png";